import {Observable} from "rxjs";
import {DashboardSettingsResponse} from "fello-model";

export abstract class AbstractDashboardSettingsService {
  abstract settings$: Observable<DashboardSettingsResponse | null>;
}
